module.exports = __webpack_public_path__ + "static/img/keHuSwiper27.86dd5ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keHuSwiper27.png
// module id = A/Rm
// module chunks = 2